// Owner-editable customer-web copy. Returns the admin value when set (non-blank), else the
// built-in fallback — so the app never shows an empty string if a key is cleared.
export function copy(shop, key, fallback = "") {
  const v = shop?.[key];
  return typeof v === "string" && v.trim() ? v : fallback;
}
